import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Typography,
    Collapse,
    IconButton,
    TablePagination,
    Snackbar, ListSubheader,
    Checkbox,
    Menu,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Select,
    FormControl,
    InputLabel,
    Slide,
    AppBar,
    Toolbar,
    Grid,
    Alert, Tabs, Tab,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PaymentsIcon from '@mui/icons-material/Payments';
import MakePayment from '../../Popupdialogbox/Makepayment';
import PrintIcon from '@mui/icons-material/Print';
import EditNoteIcon from '@mui/icons-material/EditNote';
import CloseIcon from '@mui/icons-material/Close';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { quantum, trio } from 'ldrs';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment } from '@mui/material';
//import { printSelectedRows } from './Print/InvoicePrint';
import { styled, keyframes, fontSize } from '@mui/system';
import logo from '../logo/logo.jpg';
import addressIcon from '../logo/icon/gps.png';
import emailIcon from '../logo/icon/e-mail.png';
import webIcon from '../logo/icon/world-wide-web.png';
import phoneIcon from '../logo/icon/phone.png';
import ScrollToTopButton from '../../Button/ScrollToTopButton';
import HomeIcon from '@mui/icons-material/Home';
import { motion } from 'framer-motion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Card, CardContent } from '@mui/material';
import ProfitAndLoss from '../allsales/AllSales';
import Allsales from '../allsales/AllSales'
import Due from '../allsales/due';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate } from "react-router-dom";
import { CheckCircle, AttachMoney } from '@mui/icons-material';
import { useDialogStore } from '../../Reminder/InvoiceReminder';
import Fade from '@mui/material/Fade';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';
import { ClockFading } from 'lucide-react';
import { Notyf } from 'notyf';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { CalendarToday } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import Invoicepopup from '../../Popupdialogbox/Report-popups/Invoice';
import { Share2 } from 'lucide-react';
import { CircularProgress } from '@mui/material';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const notyf = new Notyf({
    position: { x: 'left', y: 'bottom' },
    duration: 3000,
});


const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${slideInFromLeft} 0.5s ease-out`,
}));

quantum.register();
trio.register();

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const InvoiceTable = () => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const [fetchedData, setFetchedData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [openRow, setOpenRow] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const [deleteMessage, setDeleteMessage] = useState('');
    const [alertOpen, setAlertOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
    const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [payments, setPayments] = useState([]);
    const [open, setOpen] = useState(false);
    const [editOrder, setEditOrder] = useState(null);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [products, setProducts] = useState([]);
    const productPrices = {};
    const [customers, setCustomers] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [name, setName] = useState('');
    const [companyname, setCompanyName] = useState('');
    const [address, setAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [companyemail, setCompanyEmail] = useState('');
    const [password, setPassword] = useState('');
    const [image, setImage] = useState(null);
    const [showSearch, setShowSearch] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const [fetchedOrderData, setFetchedOrderData] = useState({});
    const [totalAmountDueOnReceipt, setTotalAmountDueOnReceipt] = useState({});
    const [fetchedAllPaymentData, setFetchedAllPaymentData] = useState({});
    const [totalAllPayment, setTotalAllPayment] = useState({});
    const [fetchedPaymentData, setFetchedPaymentData] = useState({});
    const [totalPayment, setTotalPayment] = useState({});
    const [combinedTotal, setCombinedTotal] = useState({});
    const [tabValue, setTabValue] = useState(0);
    const { openDialog2, invoiceNo, dueAmount, showDialog, closeDialog2 } = useDialogStore();
    const [userSubscription, setUserSubscription] = useState(null);
    const [expireuserSubscription, setExpireUserSubscription] = useState(null);
    const [emptyUserSubscription, setEmptyUserSubscription] = useState(null);
    const [anchorE2, setAnchorE2] = useState(null);
    const [openMenuRowIndex, setOpenMenuRowIndex] = useState(null);
    const [isSharing, setIsSharing] = useState(false);

    // Add these three new state variables
    const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [pdfFile, setPdfFile] = useState(null);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };
    const toggleSearch = () => {
        setIsSearchOpen(!isSearchOpen);
    };

    const handleSearchClick = () => {
        setShowSearch((prev) => !prev);
    };

    const selectedRowsData = fetchedData.filter((order) => selectedRows.includes(order.id));
    const handleClickOpen = () => setOpen(true);

    const handleSnackbar = (message, severity) => {
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };


    useEffect(() => {
        if (token) {
            localStorage.setItem('token', token);
        }
    }, [token]);


    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/");
                return;
            }

            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/");
                }
            }
        };

        fetchProfile();
    }, []);

    {/**useEffect(() => {
        if (user.id) {
            fetchData();
            fetchPaymentData();
            fetchOrderPaymentData();
            fetchPayments();
            fetchOrderData();
            updateCombinedTotal();
        }
    }, [user.id]);*/}

    {/**useEffect(() => {
        fetchData();
        fetchOrderData();
        fetchPayments();
        fetchOrderPaymentData();
    }, []);*/}

    useEffect(() => {
        if (user.id) {
            setLoading(true);

            const fetchDataPromises = [
                fetchData(),
                fetchPaymentData(),
                fetchOrderPaymentData(),
                fetchPayments(),
                fetchOrderData()
            ];

            Promise.all(fetchDataPromises)
                .then(() => {
                })
                .catch(error => {
                    console.error('Error during data fetching:', error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [user.id]);


    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-data');

            // Ensure user.id exists before logging and filtering
            if (user.id) {

                // Filter orders based on user.id
                const Orders = response.data.filter(order =>
                    order.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );

                setFetchedData(Orders);
                setFilteredData(Orders);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPaymentData = async () => {
        setLoading(true);
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-payment-data');
            if (user.id) {
                const Payment = response.data.filter(payment =>
                    payment.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );
                setPayments(Payment);
                setLoading(false);
            }
            setPayments(response.data);
        } catch (error) {
            console.error('Error fetching payment data:', error);
        } finally {
            setLoading(false);
        }
    };


    const handleRowClick = (index) => {
        setOpenRow(openRow === index ? null : index);
    };

    const handleRowSelect = (event, orderId) => {
        const selectedIndex = selectedRows.indexOf(orderId);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, orderId);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1),
            );
        }

        setSelectedRows(newSelected);
    };

    const isSelected = (orderId) => selectedRows.indexOf(orderId) !== -1;


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const calculateTotalAmount = (items, discount) => {
        // Calculate the total amount considering item-specific taxes
        const totalAmount = items.reduce((acc, item) => {
            const itemTotal = Number(Number(item.price)) + (Number(Number(item.price)) * (item.tax / 100));
            return acc + itemTotal;
        }, 0);

        // Apply discount
        const discountedAmount = totalAmount - (totalAmount * (discount / 100));

        // Calculate total amount
        return discountedAmount;
    };

    const calculateDiscountTotalAmount = (items, discount) => {
        // Calculate the total amount considering item-specific taxes
        const totalAmount = items.reduce((acc, item) => {
            const itemTotal = Number(item.price) * (discount / 100);
            return acc + itemTotal;
        }, 0);

        // Apply discount
        const discountedTotalAmount = totalAmount - (totalAmount * (discount / 100));

        // Calculate total amount
        return discountedTotalAmount;
    };


    const calculateOrderTotalPayments = (orderId) => {
        // Calculate total payments made for this order
        return payments
            .filter(payment => payment.payment_id === orderId)
            .reduce((total, payment) => total + Number(payment.amount), 0);
    };

    const calculateTotalTaxAmount = (items) => {
        // Calculate the total amount considering item-specific taxes
        const totalAmount = items.reduce((acc, item) => {
            const itemTotal = Number(item.price) * (item.tax / 100);
            return acc + itemTotal;
        }, 0);

        return totalAmount;
    };

    {/**const handleDelete = async () => {
        setLoading(true);
        try {
            // Delete selected rows and corresponding payment data
            const promises = selectedRows.map(async (id) => {
                // Delete main data
                await axios.delete(`https://admin.bizstor.lk/public/api/delete-data/${id}`);
                // Delete related payment data based on payment_id
                await axios.delete(`https://admin.bizstor.lk/public/api/auto-delete-payment-data/${id}`);
            });
            await Promise.all(promises);

            // Update frontend state
            setFetchedData(fetchedData.filter(order => !selectedRows.includes(order.id)));
            handleSnackbar('Selected invoice and payments deleted successfully!', 'success');
            setSelectedRows([]); // Clear selected rows
            setDeleteConfirmationOpen(false); // Close delete confirmation dialog
            fetchData(); // Refresh data
        } catch (error) {
            console.error('Error deleting data:', error);
            handleSnackbar('Error deleting invoice or payments!', 'error');
        } finally {
            setLoading(false);
        }
    };*/}


    const handleDelete = async () => {
        setLoading(true);
        try {
            const promises = selectedRows.map(async (id) => {
                try {
                    // Delete main order data
                    await axios.delete(`https://admin.bizstor.lk/public/api/delete-data/${id}`);

                    // Attempt to delete related payment data, but ignore errors if it doesn't exist
                    await axios.delete(`https://admin.bizstor.lk/public/api/auto-delete-payment-data/${id}`).catch(error => {
                        if (error.response && error.response.status === 404) {
                            console.warn(`Payment data for order ${id} not found, skipping...`);
                        } else {
                            throw error; // Re-throw other errors
                        }
                    });
                } catch (err) {
                    console.error(`Error deleting order ${id}:`, err);
                    throw err; // Ensures a failed delete still rejects the Promise.all
                }
            });

            await Promise.all(promises);

            // Update frontend state
            setFetchedData(fetchedData.filter(order => !selectedRows.includes(order.id)));
            //handleSnackbar('Selected invoice deleted successfully!', 'success');
            notyf.success('Selected invoice deleted successfully!');
            setSelectedRows([]); // Clear selected rows
            setDeleteConfirmationOpen(false); // Close delete confirmation dialog
            fetchData(); // Refresh data
        } catch (error) {
            //console.error('Error deleting data:', error);
            //handleSnackbar('Error deleting invoice(s)!', 'error');
            notyf.error('Error deleting invoices!');

        } finally {
            setLoading(false);
        }
    };


    const clearDeleteMessage = () => {
        setDeleteMessage('');
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleOpenDeleteConfirmation = () => {
        setDeleteConfirmationOpen(true);
    };

    const handleCloseDeleteConfirmation = () => {
        setDeleteConfirmationOpen(false);
    };

    const handleOpenPaymentDialog = (order) => {
        setSelectedOrder(order);
        setPaymentDialogOpen(true);
    };



    const handleClosePaymentDialog = () => {
        setPaymentDialogOpen(false);
    };


    {/*updated*/ }

    const handleEditClick = (order) => {
        setEditOrder(order);
        setEditDialogOpen(true);
    };

    const handleCloseEditDialog = () => {
        setEditDialogOpen(false);
        setEditOrder(null);
    };

    const handleEditChange = (field, value) => {
        const updatedOrder = { ...editOrder, [field]: value };

        if (field === 'term' && editOrder.invoicedate) {
            const invoiceDate = new Date(editOrder.invoicedate);
            let dueDate = invoiceDate;

            if (value === 'net 15') {
                dueDate.setDate(invoiceDate.getDate() + 15);
            } else if (value === 'net 30') {
                dueDate.setDate(invoiceDate.getDate() + 30);
            } else if (value === 'net 60') {
                dueDate.setDate(invoiceDate.getDate() + 60);
            }

            updatedOrder.duedate = dueDate.toISOString().split('T')[0];
        }

        setEditOrder(updatedOrder);
    };


    const handleEditItemChange = (index, field, value) => {
        const updatedItems = [...editOrder.items];
        updatedItems[index][field] = value;
        setEditOrder(prevState => ({ ...prevState, items: updatedItems }));
    };

    const handleAddNewItem = () => {
        // Get the current date in the desired format (e.g., YYYY-MM-DD)
        const currentDate = new Date().toISOString().split('T')[0];

        setEditOrder(prevState => ({
            ...prevState,
            items: [
                ...prevState.items,
                {
                    product: '',
                    quantity: '',
                    rate: '',
                    price: '',
                    servicedate: currentDate,
                    tax: ''
                }
            ]
        }));
    };


    const handleEditSave = async () => {
        setLoading(true);

        try {
            const response = await axios.put(`https://admin.bizstor.lk/public/api/update-order/${editOrder.id}`, {
                fullname: editOrder.fullname,
                customer: editOrder.customer === 'Direct Customer' ? 'Direct Customer' : 'Existing Customer',
                address: editOrder.address,
                email: editOrder.email,
                term: editOrder.term,
                invoicedate: editOrder.invoicedate,
                duedate: editOrder.duedate,
                description: editOrder.description,
                discount: editOrder.discount,
                payamount: editOrder.payamount,

                items: editOrder.items.map(item => ({
                    product: item.product,
                    quantity: item.quantity,
                    rate: item.rate,
                    price: Number(item.price),
                    servicedate: item.servicedate,
                    tax: item.tax,
                }))
            });
            console.log(response.data);
            setEditDialogOpen(false);
            //handleSnackbar('Invoice updated successfully!', 'success');
            notyf.success('Invoice updated successfully!');
            fetchData();
        } catch (error) {
            //console.error('There was an error updating the order:', error.response.data);
            notyf.error('here was an error updating the Invoice!');
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        axios.get('https://admin.bizstor.lk/public/api/get-product-data')
            .then(response => {
                if (user.id) {
                    {/**console.log('User ID:', user.id);*/ }

                    // Filter products based on user token
                    const filteredProducts = response.data.products.filter(product =>
                        product.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                    );
                    setProducts(filteredProducts);
                } else {
                    setProducts(response.data.products); // Set all products if no user token
                }
            })
            .catch(error => {
                console.error('Error fetching product data:', error);
            });
    }, [user.id]); // Dependency array includes user.id


    products.forEach(product => {
        productPrices[product.product] = product.price;
    });

    const handleProductChange = (index, value) => {
        const rate = productPrices[value];
        handleEditItemChange(index, 'product', value);
        handleEditItemChange(index, 'rate', rate);
        const quantity = editOrder.items[index].quantity || 0;
        handleEditItemChange(index, 'price', rate * quantity);
    };

    const handleQuantityChange = (index, value) => {
        handleEditItemChange(index, 'quantity', value);
        const rate = editOrder.items[index].rate || 0;
        handleEditItemChange(index, 'price', rate * value);
    };

    const handleRateChange = (index, value) => {
        handleEditItemChange(index, 'rate', value);
        const quantity = editOrder.items[index].quantity || 0;
        handleEditItemChange(index, 'price', value * quantity);
    };

    const handleDeleteItem = (index) => {
        const updatedItems = [...editOrder.items];
        updatedItems.splice(index, 1);
        setEditOrder({ ...editOrder, items: updatedItems });
    };

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                setLoading(true); // Start loading
                const response = await axios.get('https://admin.bizstor.lk/public/api/get-customer-data');

                if (user.id) {
                    {/**console.log('User ID:', user.id);*/ }

                    // Filter customers based on user token
                    const filteredCustomers = response.data.customers.filter(customer =>
                        customer.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                    );
                    setCustomers(filteredCustomers);
                } else {
                    setCustomers(response.data.customers); // Set all customers if no user token
                }
            } catch (error) {
                console.error('Error fetching customers:', error);
            } finally {
                setLoading(false); // End loading
            }
        };

        fetchCustomers();
    }, [user.id]);


    const handleAutoFill = (field, value) => {
        if (field === 'customer') {
            if (value === 'Direct Customer') {
                setEditOrder(prevState => ({
                    ...prevState,
                    customer: value,
                    fullname: '',
                    email: '',
                    address: ''
                }));
            } else {
                const selectedCustomer = customers.find(customer => customer.id === value);
                setEditOrder(prevState => ({
                    ...prevState,
                    customer: value,
                    fullname: selectedCustomer.firstname,
                    email: selectedCustomer.email,
                    address: selectedCustomer.address
                }));
            }
        } else {
            setEditOrder(prevState => ({
                ...prevState,
                [field]: value
            }));
        }
    };

    const calculateTotalPrice = () => {
        // Check if editOrder and items are available
        if (!editOrder || !editOrder.items) return 0;

        // Calculate total with item-specific taxes included
        const total = editOrder.items.reduce((total, item) => {
            // Ensure Number(item.price) and item.tax are valid numbers
            const itemPrice = parseFloat(Number(item.price)) || 0;
            const itemTax = parseFloat(item.tax) || 0;

            const itemTotal = itemPrice + (itemPrice * (itemTax / 100));
            return total + itemTotal;
        }, 0);

        // Get discount percentage and pay amount, ensuring they are valid numbers
        const discountPercentage = parseFloat(editOrder.discount) || 0;
        const payAmount = parseFloat(editOrder.payamount) || 0;

        // Calculate discount amount and final total
        const discountAmount = (total * discountPercentage) / 100;
        const finalTotal = total - discountAmount - payAmount;

        return finalTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const [selectedMonth, setSelectedMonth] = useState('');

    const handleSearchChange = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
        filterData(value, selectedMonth);
    };

    const handleMonthChange = (event) => {
        const value = event.target.value;
        setSelectedMonth(value);
        filterData(searchTerm, value);
    };

    const filterData = (term, month) => {
        const filtered = fetchedData.filter(order => {
            const orderDate = new Date(order.invoicedate);
            const orderMonth = orderDate.toLocaleString('default', { month: 'long' }).toLowerCase();

            return (
                (term === '' ||
                    (order.invoiceNo && order.invoiceNo.toString().includes(term)) ||
                    (order.fullname && order.fullname.toLowerCase().includes(term)) ||
                    (order.pay_id && order.pay_id.toLowerCase().includes(term)) ||
                    (order.invoicedate && order.invoicedate.includes(term))
                ) &&
                (month === '' || orderMonth === month.toLowerCase())
            );
        });
        setFilteredData(filtered);
    };


    useEffect(() => {

        const fetchProfile = async () => {
            if (!token) return; // Exit if no token

            try {
                const response = await axios.get('https://admin.bizstor.lk/public/api/profile', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setUser(response.data);
                setName(response.data.name);
                setCompanyName(response.data.companyname);
                setAddress(response.data.address);
                setPhone(response.data.phone);
                setCompanyEmail(response.data.companyemail);
                setEmail(response.data.email);
            } catch (error) {
                console.log('');
            }
        };

        fetchProfile();
    }, [token]);


    const printSelectedRows = (data) => {
        const printWindow = window.open('', '_blank');
        const currentDate = new Date().toLocaleDateString();

        const firstInvoiceNo = data.length > 0 ? data[0].invoiceNo : 'N/A';

        let printContent = `
          <html >
    <head>
        <title>Invoice - #${firstInvoiceNo}</title>
    </head>
    <body style="font-family: Arial, sans-serif; margin: 10px; padding: 20px; background-color: #f8f9fa;">
        <div style=" margin: 0 auto; background-color: #fff; padding: 30px; border-radius: 8px; ;">
            <!-- Header Section -->
            <div style="text-align: center; margin-bottom: 30px;">
                <img src=${`https://admin.bizstor.lk/storage/app/public/images/${user.image}`} alt="Company Logo" style="max-width: 100px; margin-bottom: 15px;">
                <h1 style="margin: 0; font-size: 26px; color: #2c3e50; font-weight: 600; text-transform: uppercase">${user.companyname}</h1>
                <p style="margin: 5px 0; font-size: 14px; color: #7f8c8d;">${user.address ? user.address : ''}</p>
                <p style="margin: 5px 0; font-size: 14px; color: #7f8c8d;"> ${user.phone ? `Phone: ${user.phone}` : ''}  ${user.companyemail ? ` | Email: ${user.companyemail}` : ''}  ${user.website ? ` | Web: ${user.website}` : ''}</p>
            </div>

        `;

        data.forEach(order => {
            const totalAmount = order.items.reduce((acc, item) => acc + (item.quantity * item.rate), 0);
            const grandTotal = calculateTotalAmount(order.items, order.discount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const discount = (order.discount);
            const discountAmount = (totalAmount * discount) / 100;
            const taxamount = calculateTotalTaxAmount(order.items).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            const paidAmount = order.payamount + calculateOrderTotalPayments(order.id);
            const payable = calculateTotalAmount(order.items, order.discount);

            const isPaid = order.term === 'due on receipt' ? 'PAID' : (parseFloat(payable) <= (order.payamount + calculateOrderTotalPayments(order.id)) ? 'PAID' : 'PENDING');

            printContent += `
                <div style="display: flex; justify-content: space-between; margin-bottom: 30px;">
                <!-- Customer Details -->
                <div style="flex: 1;">
                    <h2 style="font-size: 18px; color: #34495e; margin-bottom: 10px; font-weight: 500;">Bill To:</h2>
                    <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Name:</strong>${order.fullname ? order.fullname : 'N/A'}</p>
                    <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Email:</strong> ${order.email ? order.email : 'N/A'}</p>
                    <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Address:</strong> ${order.address ? order.address : 'N/A'}</p>
                </div>
                <!-- Invoice Details -->
                <div style="flex: 1; text-align: right;">
                    <h2 style="font-size: 18px; color: #34495e; margin-bottom: 10px; font-weight: 500;">Invoice Details</h2>
                    <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Invoice No:</strong>#${order.invoiceNo}</p>
                    <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Date:</strong>${order.invoicedate}</p>
                    <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>status:</strong>
                    ${order.term === 'due on receipt' ? 'PAID' : // If term is 'due on receipt', show 'paid'
                    order.payamount === 0 ? 'UNPAID' : // If payamount is explicitly 0, show 'unpaid'
                        calculateTotalAmount(order.items, order.discount) <= (Number(order.payamount) + calculateOrderTotalPayments(order.id)) ? 'paid' : // If total amount matches, show 'paid'
                            'PENDING' // Otherwise, show 'pending'
                }
                    </p>
                </div>
            </div>

            `;

            printContent += `
              <table id="invoice-table" style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
                <thead>
                    <tr style="background-color: none; color: #fff;">
                        <th style="padding: 12px; border: 1px solid #ddd; text-align: left; color: #34495e;">Product</th>
                        <th style="padding: 12px; border: 1px solid #ddd; text-align: left; color: #34495e;">Quantity</th>
                        <th style="padding: 12px; border: 1px solid #ddd; text-align: left; color: #34495e;">Rate</th>
                        <th style="padding: 12px; border: 1px solid #ddd; text-align: left; color: #34495e;">Amount</th>
                        <th style="padding: 12px; border: 1px solid #ddd; text-align: left; color: #34495e;">Tax</th>
                    </tr>
                </thead>
                <tbody>
            `;

            order.items.forEach((item) => {
                printContent += `
                    <tr>
                        <td style="padding: 12px; border: 1px solid #ddd;">${item.product}</td>
                        <td style="padding: 12px; border: 1px solid #ddd;">${item.quantity}</td>
                        <td style="padding: 12px; border: 1px solid #ddd;">${Number(item.rate).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        <td style="padding: 12px; border: 1px solid #ddd;">${Number(item.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        <td style="padding: 12px; border: 1px solid #ddd;">${item.tax ? item.tax : 'N/A'}</td>
                    </tr>
                `;
            });

            printContent += `
                    </tbody>
                </table>
            `;

            printContent += `
            <div style="text-align: right; background-color: #f8f9fa; padding: 20px; border-radius: 6px; margin-bottom: 20px;">
                <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Subtotal:</strong>Lkr.${(totalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Tax:</strong>Lkr.${taxamount}</p>
                <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Discount:</strong> Lkr.${discountAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                <p style="margin: 5px 0; font-size: 18px; color: #2c3e50; font-weight: 600;"><strong>Grand Total:</strong> Lkr.${grandTotal}</p>
            </div>

            <div style="background-color: #f8f9fa; padding: 20px; border-radius: 6px; margin-bottom: 20px;">
                <h2 style="font-size: 18px; color: #34495e; margin-bottom: 10px; font-weight: 500;">Payment Details</h2>
                <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Payment:</strong> Lkr.${order.term === 'due on receipt'
                    ? grandTotal
                    : (Number(order.payamount) + calculateOrderTotalPayments(order.id)).toFixed(2)}</p>
                    ${order.term !== 'due on receipt' ? `</p>
                <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Payable:</strong> Lkr.${((payable) - (Number(order.payamount) + calculateOrderTotalPayments(order.id))).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
            </div>

                ` : ''}
                `;


            printContent += `<div style="text-align: center; margin-top: 30px; font-size: 12px; color: #7f8c8d;">
                <p>Thank you for your business!</p>
                <p>If you have any questions, please contact us at ${user.phone}.</p>
            </div>`;


        });

        printContent += '</body></html>';

        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.focus();

        setTimeout(() => {
            printWindow.print();
        }, 1000);
    };

    const fetchOrderData = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-data');
            if (user.id) {
                // Filter orders with term 'due on receipt'
                const Order = response.data.filter(order =>
                    order.usertoken.toLowerCase() === user.id.toString().toLowerCase() &&
                    order.term === 'due on receipt'
                );

                let total = 0;

                Order.forEach(order => {
                    let orderTotal = 0;

                    // Loop through order items to calculate item total with tax
                    order.items.forEach(item => {
                        const itemPrice = Number(item.price);
                        const itemTax = item.tax || 0;
                        const itemTotal = itemPrice + (itemPrice * (itemTax / 100)); // Adding item-specific tax
                        orderTotal += itemTotal;
                    });

                    // Calculate discount and apply it to the order total
                    const discountPercentage = order.discount || 0;
                    const discountAmount = (orderTotal * discountPercentage) / 100; // Calculate discount amount
                    orderTotal -= discountAmount; // Apply discount

                    // Add the order total to the overall total
                    total += orderTotal;
                });

                // Set the fetched order data and the total amount
                setFetchedOrderData(Order);
                setTotalAmountDueOnReceipt(total); // Assuming you have a state to store the total amount

            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const fetchPayments = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-payment-data');
            if (user.id) {
                const Payment = response.data.filter(payment =>
                    payment.usertoken.toLowerCase() === user.id.toString().toLowerCase()
                );

                let totalallpayment = 0;

                Payment.forEach(payment => {
                    // Add the payment amount directly
                    totalallpayment += payment.amount || 0; // If amount is missing, default to 0
                });

                // Set the total payment amount
                setFetchedAllPaymentData(Payment);
                setTotalAllPayment(totalallpayment); // Assuming you have a state to store the total payment

            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    const fetchOrderPaymentData = async () => {
        try {
            const response = await axios.get('https://admin.bizstor.lk/public/api/get-data');
            if (user.id) {
                const Order = response.data.filter(order =>
                    order.usertoken.toLowerCase() === user.id.toString().toLowerCase() &&
                    order.term !== 'due on receipt'
                );

                let totalpay = 0;

                // Loop through the filtered orders and add the payamount to the total payment
                Order.forEach(order => {
                    let orderTotal = 0;

                    // Add the payamount directly to the order total
                    orderTotal += Number(order.payamount) || 0; // If payamount is missing, default to 0

                    // Accumulate the total pay
                    totalpay += orderTotal;
                });

                // Set the fetched order data and total payment
                setFetchedPaymentData(Order);
                setTotalPayment(totalpay); // Assuming you have a state to store the total payment

            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const updateCombinedTotal = () => {
        const combinedTotal = totalAmountDueOnReceipt + totalAllPayment + totalPayment;
        setCombinedTotal(combinedTotal);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);

        if (newValue === 0) {
            setFilteredData(fetchedData);
        } else if (newValue === 1) {
            setFilteredData(fetchedData.filter(order =>
                order.term !== 'due on receipt' &&
                (calculateTotalAmount(order.items, order.discount) >
                    (Number(order.payamount) + calculateOrderTotalPayments(order.id)))
            ));
        }

        setPage(0);
    };



    useEffect(() => {
        filteredData.forEach((order) => {
            const dueDate = new Date(order.duedate);
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            const totalAmount = calculateTotalAmount(order.items, order.discount);
            const paidAmount = Number(order.payamount) + calculateOrderTotalPayments(order.id);
            const payDue = totalAmount - paidAmount;

            if (
                dueDate.toDateString() === tomorrow.toDateString() &&
                order.term !== 'due on receipt' &&
                payDue > 0
            ) {
                showDialog(order.invoiceNo, payDue);
            }
        });
    }, [filteredData, showDialog]);


    const handleBackClick = () => {
        navigate("/allreport");
    };

    const handleDelete2 = async (id) => {
        setLoading(true); // Start loading

        try {
            await axios.delete(`https://admin.bizstor.lk/public/api/delete-data/${id}`);

            await axios.delete(`https://admin.bizstor.lk/public/api/auto-delete-payment-data/${id}`).catch(error => {
                if (error.response && error.response.status === 404) {
                    console.warn(`Payment data for order ${id} not found, skipping...`);
                } else {
                    throw error; // Re-throw other errors
                }
            });

            notyf.success('Selected invoice deleted successfully!');
            fetchData(); // Refresh data

        } catch (error) {
            notyf.error('Error deleting invoice!');
        } finally {
            setLoading(false); // Stop loading
        }
    };

    // Updated handlers
    const handleMenuOpen2 = (e, rowIndex) => {
        e.stopPropagation();
        setAnchorE2(e.currentTarget);
        setOpenMenuRowIndex(rowIndex);
    };

    const handleMenuClose2 = () => {
        setAnchorE2(null);
        setOpenMenuRowIndex(null);
    };

    const getOrderStatus = (order) => {
        const totalAmount = calculateTotalAmount(order.items, order.discount);
        const totalPaid = Number(order.payamount) + calculateOrderTotalPayments(order.id);

        if (order.term === 'due on receipt' || totalAmount <= totalPaid) {
            return 'Paid';
        } else if (order.payamount === 0) {
            return 'Unpaid';
        } else {
            return 'Pending';
        }
    };

    const pendingCount = filteredData.filter(order => getOrderStatus(order) === 'Pending').length;

    const totalFilteredInvoiceAmount = filteredData.reduce((acc, order) => {
        return acc + calculateTotalAmount(order.items, order.discount);
    }, 0);

    const totalDueAmount = filteredData.reduce((acc, order) => {
        const totalInvoice = calculateTotalAmount(order.items, order.discount);
        const totalPaid = order.term === 'due on receipt'
            ? 0
            : Number(order.payamount || 0) + calculateOrderTotalPayments(order.id);

        return acc + (totalInvoice - totalPaid);
    }, 0);


    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/get-subscription");

                const matchedSub = response.data.subscription
                    .filter(sub => sub.email === user.email && sub.status === "active")
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

                setUserSubscription(matchedSub || null);
            } catch (error) {
                console.error("Failed to fetch subscriptions", error);
            }
        };

        if (user.email) {
            fetchSubscriptions();
        }
    }, [user.email]);

    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/get-subscription");

                const matchedSub = response.data.subscription
                    .filter(sub => sub.email === user.email && sub.status === "expire")
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

                setExpireUserSubscription(matchedSub || null);
            } catch (error) {
                console.error("Failed to fetch subscriptions", error);
            }
        };

        if (user.email) {
            fetchSubscriptions();
        }
    }, [user.email]);

    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/get-subscription");

                const matchedSub = response.data.subscription
                    .filter(sub => sub.email === user.email)[0]; // get first match

                setEmptyUserSubscription(matchedSub || null); // null if no match
            } catch (error) {
                console.error("Failed to fetch subscriptions", error);
                setEmptyUserSubscription(null); // set null on error too
            }
        };

        if (user.email) {
            fetchSubscriptions();
        }
    }, [user.email]);

    const isFreePlan = userSubscription?.plan === "free";
    const isBasicPlan = userSubscription?.plan === "basic";
    const isPremiumPlan = userSubscription?.plan === "premium";
    const expire = expireuserSubscription?.plan === "free" || expireuserSubscription?.plan === "basic" || expireuserSubscription?.plan === "premium" || expireuserSubscription?.plan === "30 days free";

    const handlePrintSingleClick = (order) => {
        printSelectedRows([order]);
        handleMenuClose2();
    };

    // Inside the InvoiceTable component function

    const handleClosePreview = () => {
        // Revoke the object URL to free up memory
        if (pdfUrl) {
            URL.revokeObjectURL(pdfUrl);
        }
        setPdfPreviewOpen(false);
        setPdfUrl('');
        setPdfFile(null);
    };

const executeShare = async () => {
    if (!pdfFile) {
        notyf.error('No PDF file available to share.');
        return;
    }

    try {
        if (navigator.share && navigator.canShare({ files: [pdfFile] })) {
            await navigator.share({
                title: `Invoice #${pdfFile.name.split('-')[1].replace('.pdf', '')}`,
                text: 'Here is the invoice.',
                files: [pdfFile],
            });
            notyf.success('Invoice shared successfully!');
        } else {
            notyf.open({
                type: 'info',
                message: 'Web Share not supported on this browser.',
                duration: 5000,
            });
        }
    } catch (error) {
        if (error.name !== 'AbortError') {
            console.error('Error sharing invoice:', error);
            notyf.error('Failed to share invoice.');
        }
    }
};

const handlePreviewClick = async (order) => {
    handleMenuClose2();
    setIsSharing(true);

    try {
        const content = getInvoiceHtml(order);
        const element = document.createElement('div');

        element.style.width = '900px';
        element.style.maxWidth = '900px';
        element.style.padding = '10px';
        element.style.backgroundColor = 'white';
        element.style.position = 'absolute';
        element.style.left = '-9999px';
        element.style.top = '0';
        element.style.zIndex = '-1';
        element.innerHTML = content;
        document.body.appendChild(element);

        setTimeout(async () => {
            try {
                // 📸 Generate canvas with lower scale and JPEG compression
                const canvas = await html2canvas(element, {
                    scale: 1.2,
                    useCORS: true
                });
                document.body.removeChild(element);

                const imgData = canvas.toDataURL('image/jpeg', 0.6); // 📦 JPEG, 60% quality
                const pdf = new jsPDF('p', 'mm', 'a4');

                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                // 🧾 Add image to PDF (1 page only)
                pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
                const pdfBlob = pdf.output('blob');

                const file = new File([pdfBlob], `invoice-${order.invoiceNo}.pdf`, { type: 'application/pdf' });
                setPdfFile(file);

                const url = URL.createObjectURL(pdfBlob);
                setPdfUrl(url);

                setPdfPreviewOpen(true);

            } catch (error) {
                console.error("Error during canvas/PDF generation:", error);
                notyf.error('Failed to generate PDF. Please check the console.');
            } finally {
                setIsSharing(false);
                if (document.body.contains(element)) {
                    document.body.removeChild(element);
                }
            }
        }, 500);

    } catch (error) {
        console.error("Error setting up for PDF generation:", error);
        notyf.error('An initial error occurred. Please check the console.');
        setIsSharing(false);
    }
};


const getInvoiceHtml = (order) => {
    // --- Helper calculations from your print template ---
    const totalAmount = order.items.reduce((acc, item) => acc + (item.quantity * item.rate), 0);
    const grandTotal = calculateTotalAmount(order.items, order.discount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const discount = (order.discount);
    const discountAmount = (totalAmount * discount) / 100;
    const taxamount = calculateTotalTaxAmount(order.items).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const paidAmount = Number(order.payamount) + calculateOrderTotalPayments(order.id);
    const payable = calculateTotalAmount(order.items, order.discount);
    
    // --- Status calculation logic ---
    const status = (() => {
        if (order.term === 'due on receipt') return 'PAID';
        if (payable <= paidAmount) return 'PAID';
        if (paidAmount === 0) return 'UNPAID';
        return 'PENDING';
    })();
    
    // --- The full HTML template ---
    const printContent = `
    <html>
        <head>
            <title>Invoice - #${order.invoiceNo}</title>
        </head>
        <body style="font-family: Arial, sans-serif; margin: 0; padding: 2; background-color: #f8f9fa;">
            <div style="width: 100%; max-width: 800px; margin: 0 auto; background-color: #fff; padding: 30px;">
                
                <div style="text-align: center; margin-bottom: 30px;">
                    <img src=${`https://admin.bizstor.lk/storage/app/public/images/${user.image}`} alt="Company Logo" style="max-width: 100px; margin-bottom: 15px;">
                    <h1 style="margin: 0; font-size: 26px; color: #2c3e50; font-weight: 600; text-transform: uppercase">${user.companyname}</h1>
                    <p style="margin: 5px 0; font-size: 14px; color: #7f8c8d;">${user.address || ''}</p>
                    <p style="margin: 5px 0; font-size: 14px; color: #7f8c8d;">
                        ${user.phone ? `Phone: ${user.phone}` : ''}
                        ${user.companyemail ? ` | Email: ${user.companyemail}` : ''}
                        ${user.website ? ` | Web: ${user.website}` : ''}
                    </p>
                </div>

                <div style="display: flex; justify-content: space-between; margin-bottom: 30px;">
                    <div style="flex: 1;">
                        <h2 style="font-size: 18px; color: #34495e; margin-bottom: 10px; font-weight: 500;">Bill To:</h2>
                        <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Name:</strong> ${order.fullname || 'N/A'}</p>
                        <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Email:</strong> ${order.email || 'N/A'}</p>
                        <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Address:</strong> ${order.address || 'N/A'}</p>
                    </div>
                    <div style="flex: 1; text-align: right;">
                        <h2 style="font-size: 18px; color: #34495e; margin-bottom: 10px; font-weight: 500;">Invoice Details</h2>
                        <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Invoice No:</strong> #${order.invoiceNo}</p>
                        <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Date:</strong> ${order.invoicedate}</p>
                        <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Status:</strong> ${status}</p>
                    </div>
                </div>

                <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
                    <thead>
                        <tr style="background-color: #f2f2f2;">
                            <th style="padding: 12px; border: 1px solid #ddd; text-align: left; color: #34495e;">Product</th>
                            <th style="padding: 12px; border: 1px solid #ddd; text-align: left; color: #34495e;">Quantity</th>
                            <th style="padding: 12px; border: 1px solid #ddd; text-align: left; color: #34495e;">Rate</th>
                            <th style="padding: 12px; border: 1px solid #ddd; text-align: left; color: #34495e;">Amount</th>
                            <th style="padding: 12px; border: 1px solid #ddd; text-align: left; color: #34495e;">Tax (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${order.items.map(item => `
                            <tr>
                                <td style="padding: 12px; border: 1px solid #ddd;">${item.product}</td>
                                <td style="padding: 12px; border: 1px solid #ddd;">${item.quantity}</td>
                                <td style="padding: 12px; border: 1px solid #ddd;">${Number(item.rate).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                <td style="padding: 12px; border: 1px solid #ddd;">${Number(item.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                <td style="padding: 12px; border: 1px solid #ddd;">${item.tax ? item.tax : 'N/A'}</td>
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
                
                <div style="text-align: right; background-color: #f8f9fa; padding: 20px; border-radius: 6px; margin-bottom: 20px;">
                    <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Subtotal:</strong> LKR ${totalAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                    <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Tax:</strong> LKR ${taxamount}</p>
                    <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Discount:</strong> LKR ${discountAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                    <p style="margin: 5px 0; font-size: 18px; color: #2c3e50; font-weight: 600;"><strong>Grand Total:</strong> LKR ${grandTotal}</p>
                </div>

                <div style="background-color: #f8f9fa; padding: 20px; border-radius: 6px; margin-bottom: 20px;">
                    <h2 style="font-size: 18px; color: #34495e; margin-bottom: 10px; font-weight: 500;">Payment Details</h2>
                    <p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Paid Amount:</strong> LKR ${paidAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                    ${order.term !== 'due on receipt' ? `<p style="margin: 5px 0; font-size: 14px; color: #555;"><strong>Amount Due:</strong> LKR ${(payable - paidAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>` : ''}
                </div>

                <div style="text-align: center; margin-top: 30px; font-size: 12px; color: #7f8c8d;">
                    <p>Thank you for your business!</p>
                    <p>If you have any questions, please contact us at ${user.phone}.</p>
                </div>
            </div>
        </body>
    </html>
    `;
    
    return printContent;
    
};


    return (
        <Box
            sx={{ mt: 10 }}
        >
            <AnimatedTypography
                component="h1"
                sx={{
                    ml: { xs: 2, sm: 3 },
                    mt: { xs: 2, sm: 3 },
                    color: '',
                    letterSpacing: '0.01em',
                    fontSize: { xs: '20px', sm: '24px' },
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    {/**<Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' },
                            fontSize: { xs: '14px', sm: '16px' },
                            fontWeight: 'bold',
                            color: '',
                        }}
                    >
                        Invoice
                    </Typography>
                    <Typography
                        component="span"
                        sx={{
                            display: { xs: 'none', sm: 'inline' }, // Hidden on xs
                            ml: 1,
                            fontSize: '14px',
                            color: '',
                        }}
                    >
                        |
                    </Typography>*/}
                    <HomeIcon
                        sx={{
                            ml: 1,
                            fontSize: '18px',
                            color: '#6d7081',
                        }}
                    />
                    <Typography
                        component="span"
                        sx={{
                            ml: 0.5,
                            fontSize: '14px',
                            color: '#6d7081',
                        }}
                    >
                        - Report - Invoice
                    </Typography>
                </Box>
            </AnimatedTypography>

            {/**<AnimatedTypography
                component="h1"
                sx={{
                    ml: 3,
                    mt: 3,
                    fontSize: '1rem',
                    color: 'secondary.main',
                    letterSpacing: '0.01em'
                }}
            >
                Dashboard / Report / Invoice
            </AnimatedTypography>*/}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: {sm:'95%',xs:'90%'},
                    maxWidth: 'auto',
                    margin: 'auto',
                    padding: '10px',
                    bgcolor: 'background.paper',
                    border: '1px solid #EDF2F7',
                    borderRadius: '16px',
                    marginTop: '30px',
                    position: 'relative',
                    '@media (max-width: 600px)': {
                        marginTop: '10px',
                    },
                }}
            >
                <Typography variant="h4">

                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' }, // Responsive direction
                        justifyContent: 'space-between', // Space between left and right groups
                        alignItems: 'center', // Align items vertically
                        p: 2, // Padding inside the box
                        gap: 2, // Space between sections
                    }}
                >


                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'left',
                            '@media (max-width: 600px)': {
                                margin: 'auto',
                            },

                        }}
                    >
                        <Box sx={{ color: '#1e293b', }}><h2>Invoice</h2></Box>
                        <Box
                            component="div"
                            sx={{
                                mb: { sm: 2, xs: 'none' },
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                color: 'primary.main',
                                width: 'fit-content',
                                '&:hover': {
                                    color: 'primary.main',
                                }
                            }}
                            onClick={handleBackClick}
                        >
                            <ArrowBackIcon fontSize="small" />
                            <Typography
                                variant="body2"
                                sx={{
                                    ml: 0.5,
                                    fontWeight: 500
                                }}
                            >
                                Back to Report
                            </Typography>
                        </Box>
                    </Box>


                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: isSearchOpen ? 1 : 0, height: isSearchOpen ? 'auto' : 0 }}
                        transition={{ duration: 0.3 }}
                        style={{ overflow: 'hidden', }}
                    >
                        {/* Left side: Search fields */}
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', sm: 'row' },
                                gap: 1, // Space between the TextFields
                                width: '80%', // Ensure it takes full width on smaller screens
                                alignItems: 'center', // Align items vertically
                                '@media (max-width: 600px)': {
                                    margin: 'auto',
                                },
                            }}
                        >
                            {/**  <Box>
                            <IconButton
                                onClick={handleSearchClick}
                                sx={{
                                    mb: 1
                                }}
                            >
                                <SearchIcon />
                            </IconButton>
                            <Collapse in={showSearch} timeout="auto">
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', sm: 'row' },
                                        gap: 1, // Space between the TextFields
                                        width: '80%', // Ensure it takes full width on smaller screens
                                        alignItems: 'center', // Align items vertically

                                    }}
                                >
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        onChange={handleSearchChange}
                                        value={searchTerm}
                                        size="small"
                                        placeholder="Search…"

                                        sx={{ width: '250px' }}
                                    />
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        onChange={handleSearchChange}
                                        value={searchTerm}
                                        size="small"
                                        type="date"

                                        sx={{ width: '250px' }}
                                    />

                                    <Select
                                        value={selectedMonth}
                                        onChange={handleMonthChange}
                                        displayEmpty
                                        size="small"
                                        sx={{
                                            width: '250px',
                                            height: '40px',
                                            mt: 1
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>All Months</em>
                                        </MenuItem>
                                        <MenuItem value="January">January</MenuItem>
                                        <MenuItem value="February">February</MenuItem>
                                        <MenuItem value="March">March</MenuItem>
                                        <MenuItem value="April">April</MenuItem>
                                        <MenuItem value="May">May</MenuItem>
                                        <MenuItem value="June">June</MenuItem>
                                        <MenuItem value="July">July</MenuItem>
                                        <MenuItem value="August">August</MenuItem>
                                        <MenuItem value="September">September</MenuItem>
                                        <MenuItem value="October">October</MenuItem>
                                        <MenuItem value="November">November</MenuItem>
                                        <MenuItem value="December">December</MenuItem>
                                    </Select>
                                </Box>
                            </Collapse>
                        </Box>
                        */}


                            <TextField
                                variant="outlined"
                                margin="normal"
                                onChange={handleSearchChange}
                                value={searchTerm}
                                size="small"
                                placeholder="Search…"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    width: '250px',
                                    borderRadius: '8px',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                    },
                                }}
                            />

                            <TextField
                                variant="outlined"
                                margin="normal"
                                onChange={handleSearchChange}
                                value={searchTerm}
                                size="small"
                                type="date"
                                sx={{
                                    width: '250px',
                                    borderRadius: '8px',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                    },
                                }}
                            />

                            <Select
                                value={selectedMonth}
                                onChange={handleMonthChange}
                                displayEmpty
                                size="small"
                                sx={{
                                    width: '250px',
                                    height: '40px',
                                    mt: 1,
                                    borderRadius: '8px',
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                    },
                                }}
                            >
                                <MenuItem value="">
                                    <em>All Months</em>
                                </MenuItem>
                                <MenuItem value="January">January</MenuItem>
                                <MenuItem value="February">February</MenuItem>
                                <MenuItem value="March">March</MenuItem>
                                <MenuItem value="April">April</MenuItem>
                                <MenuItem value="May">May</MenuItem>
                                <MenuItem value="June">June</MenuItem>
                                <MenuItem value="July">July</MenuItem>
                                <MenuItem value="August">August</MenuItem>
                                <MenuItem value="September">September</MenuItem>
                                <MenuItem value="October">October</MenuItem>
                                <MenuItem value="November">November</MenuItem>
                                <MenuItem value="December">December</MenuItem>
                            </Select>

                        </Box>
                    </motion.div>


                    <Box
                        sx={{
                            display: 'none',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: 1,
                            width: '80%',
                            alignItems: 'left',
                            '@media (max-width: 600px)': {
                                margin: 'auto',
                            },
                        }}
                    >
                        <TextField
                            variant="outlined"
                            margin="normal"
                            onChange={handleSearchChange}
                            value={searchTerm}
                            size="small"
                            placeholder="Search…"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                width: '250px',
                                borderRadius: '20px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '20px',
                                },
                            }}
                        />

                        <TextField
                            variant="outlined"
                            margin="normal"
                            onChange={handleSearchChange}
                            value={searchTerm}
                            size="small"
                            type="date"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <CalendarToday />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                width: '250px',
                                borderRadius: '20px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '20px',
                                },
                            }}
                        />

                        <Select
                            value={selectedMonth}
                            onChange={handleMonthChange}
                            displayEmpty
                            size="small"
                            sx={{
                                width: '250px',
                                height: '40px',
                                mt: 2,
                                borderRadius: '20px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '20px',
                                },
                            }}
                        >
                            <MenuItem value="">
                                <em>All Months</em>
                            </MenuItem>
                            <MenuItem value="January">January</MenuItem>
                            <MenuItem value="February">February</MenuItem>
                            <MenuItem value="March">March</MenuItem>
                            <MenuItem value="April">April</MenuItem>
                            <MenuItem value="May">May</MenuItem>
                            <MenuItem value="June">June</MenuItem>
                            <MenuItem value="July">July</MenuItem>
                            <MenuItem value="August">August</MenuItem>
                            <MenuItem value="September">September</MenuItem>
                            <MenuItem value="October">October</MenuItem>
                            <MenuItem value="November">November</MenuItem>
                            <MenuItem value="December">December</MenuItem>
                        </Select>
                    </Box>


                    {/* Right side: Icons */}
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1, // Space between the icons
                            mt: { xs: 2, sm: 0 }, // Add margin-top on small screens
                            justifyContent: { xs: 'center', sm: 'flex-end' }, // Center on small screens
                            width: { xs: '80%', sm: 'auto' }, // Full width on small screens

                        }}
                    >
                        <IconButton onClick={fetchData} aria-label="Refresh data">
                            <RefreshIcon />
                        </IconButton>
                        <IconButton
                            onClick={toggleSearch}
                            sx={{
                                display: { sm: 'none', xs: 'flex' }
                            }}
                        >
                            <SearchIcon />
                        </IconButton>
                        <IconButton
                            aria-label="print"
                            onClick={() => printSelectedRows(selectedRowsData)}
                            disabled={selectedRows.length === 0}
                        >
                            <PrintIcon />
                        </IconButton>

                        <IconButton
                            aria-label="delete"
                            onClick={handleMenuOpen}
                            disabled={selectedRows.length === 0}
                        >
                            <DeleteIcon
                                sx={{
                                    '&:hover': {
                                        color: 'red',
                                    },
                                }}
                            />
                        </IconButton>
                        <IconButton
                            onClick={handleToggle}
                            sx={{
                                display: { sm: 'none', xs: 'flex', md: 'none' }
                            }}
                        >
                            {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </Box>
                </Box>

                <Box>
                    {isOpen && (
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 1 }}
                        >

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Card sx={{ height: '50px', bgcolor: 'white', }}>
                                        <CardContent
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between'
                                            }}
                                        >
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold' }}>Total Sales</Typography>
                                            <Typography sx={{}}>LKR.{totalFilteredInvoiceAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography>

                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <Card sx={{ height: '50px', bgcolor: 'white', }}>
                                        <CardContent
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between'
                                            }}
                                        >
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold' }}>Credit</Typography>
                                            <Typography sx={{}}> LKR.{totalDueAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <Card sx={{ height: '50px', bgcolor: 'white', }}>
                                        <CardContent
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between'
                                            }}
                                        >
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold' }}>Total orders</Typography>
                                            <Typography sx={{}}>{filteredData.length}</Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <Card sx={{ height: '50px', bgcolor: 'white', }}>
                                        <CardContent
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                justifyContent: 'space-between'
                                            }}
                                        >
                                            <Typography sx={{ fontSize: '15px', fontWeight: 'bold' }}>Pending orders</Typography>
                                            <Typography sx={{}}>{pendingCount}</Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>

                            </Grid>
                        </motion.div>
                    )}
                </Box>


                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                >
                    <MenuItem onClick={handleOpenDeleteConfirmation}>
                        Delete Selected Invoice
                    </MenuItem>
                </Menu>
                <Snackbar
                    open={alertOpen}
                    autoHideDuration={6000}
                    onClose={() => setAlertOpen(false)}
                    message="Deleted successfully!"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                />
                <Dialog
                    open={deleteConfirmationOpen}
                    onClose={handleCloseDeleteConfirmation}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Are you sure you want to delete selected orders?"}</DialogTitle>
                    <DialogActions>
                        <Button onClick={handleCloseDeleteConfirmation} color="primary">
                            No
                        </Button>
                        <Button onClick={handleDelete}
                            sx={{
                                backgroundColor: 'red',
                                color: 'white',
                                '&:hover': {
                                    color: 'white',
                                    backgroundColor: 'red',
                                },
                            }}
                        >
                            Yes
                        </Button>
                    </DialogActions>

                    {loading && (
                        <Box sx={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'white',
                            zIndex: 9999
                        }}>
                            <l-trio
                                size="50"
                                speed="1.3"
                                color="red"
                            ></l-trio>
                        </Box>
                    )}
                </Dialog>

                <Box
                    sx={{
                        display: { sm: 'flex', md: 'flex', xs: 'none' },
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        width: '98%',
                        height: '100px',
                        margin: 'auto'
                    }}
                >
                    <Box
                        sx={{
                            bgcolor: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '30%',
                            height: '120px',
                            margin: 'auto',
                            gap: 1
                        }}
                    >
                        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', color: 'rgb(36, 36, 36)' }}>Total Sales</Typography>
                        <Typography sx={{ fontSize: '25px', fontWeight: 800 }}><Allsales /></Typography>
                    </Box>
                    <Box
                        sx={{
                            bgcolor: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '30%',
                            height: '120px',
                            margin: 'auto',
                            gap: 1
                        }}
                    >
                        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', color: 'rgb(36, 36, 36)' }}>Credit</Typography>
                        <Typography sx={{ fontSize: '25px', fontWeight: 800 }}><Due /></Typography>
                    </Box>
                    <Box
                        sx={{
                            bgcolor: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '20%',
                            height: '120px',
                            margin: 'auto',
                            gap: 1
                        }}
                    >
                        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', color: 'rgb(36, 36, 36)' }}>Total orders</Typography>
                        <Typography sx={{ fontSize: '25px', fontWeight: 800 }}>{filteredData.length}</Typography>
                    </Box>
                    <Box
                        sx={{
                            bgcolor: 'white',
                            display: 'flex',
                            flexDirection: 'column',
                            width: '20%',
                            height: '120px',
                            margin: 'auto',
                            gap: 1
                        }}
                    >
                        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', color: 'rgb(36, 36, 36)' }}>Pending orders</Typography>
                        <Typography sx={{ fontSize: '25px', fontWeight: 800 }}>{pendingCount}</Typography>
                    </Box>

                </Box>


                <Box
                    sx={{
                        display: { sm: 'flex', xs: 'none' },
                        flexDirection: 'row',
                        width: '100%',
                        height: '50px',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '20%',
                        }}
                    >
                        <TextField
                            variant="outlined"
                            margin="normal"
                            onChange={handleSearchChange}
                            value={searchTerm}
                            size="small"
                            placeholder="Search…"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                mt: 1,
                                width: '245px',
                                borderRadius: '8px',
                                bgcolor: 'rgba(240, 240, 240, 0.17)',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                },
                            }}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '20%',
                        }}
                    >
                        <TextField
                            variant="outlined"
                            margin="normal"
                            onChange={handleSearchChange}
                            value={searchTerm}
                            size="small"
                            type="date"
                            sx={{
                                width: '245px',
                                mt: 1,
                                bgcolor: 'rgba(240, 240, 240, 0.17)',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                },
                            }}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '20%',
                        }}
                    >
                        <Select
                            value={selectedMonth}
                            onChange={handleMonthChange}
                            displayEmpty
                            size="small"
                            sx={{
                                width: '245px',
                                height: '40px',
                                mt: 0,
                                bgcolor: 'rgba(240, 240, 240, 0.17)',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '8px',
                                },
                            }}
                        >
                            <MenuItem value="">
                                <em>All Months</em>
                            </MenuItem>
                            <MenuItem value="January">January</MenuItem>
                            <MenuItem value="February">February</MenuItem>
                            <MenuItem value="March">March</MenuItem>
                            <MenuItem value="April">April</MenuItem>
                            <MenuItem value="May">May</MenuItem>
                            <MenuItem value="June">June</MenuItem>
                            <MenuItem value="July">July</MenuItem>
                            <MenuItem value="August">August</MenuItem>
                            <MenuItem value="September">September</MenuItem>
                            <MenuItem value="October">October</MenuItem>
                            <MenuItem value="November">November</MenuItem>
                            <MenuItem value="December">December</MenuItem>
                        </Select>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '20%',

                        }}
                    >

                    </Box>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-end',
                            justifyContent: 'flex-end',
                            width: '20%',

                        }}
                    >
                        <Invoicepopup />

                    </Box>
                </Box>

                <Box sx={{ width: '100%', mb: 2 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        sx={{
                            borderBottom: 1,
                            borderColor: 'divider',
                            '& .MuiTabs-indicator': { backgroundColor: 'rgb(45,55,72)' }
                        }}>
                        <Tab
                            label="All"
                            sx={{
                                color: 'rgb(45,55,72)',
                                '&.Mui-selected': { color: 'rgb(45,55,72)' },
                                fontWeight: 'bold'
                            }}
                        />
                        <Tab
                            label="Pending"
                            sx={{
                                color: 'rgb(45,55,72)',
                                '&.Mui-selected': { color: 'rgb(45,55,72)' },
                                fontWeight: 'bold'
                            }}
                        />
                    </Tabs>


                    <TableContainer style={{ marginTop: '20px' }}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ '& td, & th': { padding: '8px 12px', bgcolor: '#F7FAFC' } }}>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                            checked={selectedRows.length === filteredData.length && filteredData.length > 0}
                                            onChange={() => {
                                                if (selectedRows.length === filteredData.length) {
                                                    setSelectedRows([]);
                                                } else {
                                                    setSelectedRows(filteredData.map((order) => order.id));
                                                }
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell><b>Invoice Date</b></TableCell>
                                    <TableCell><b>Invoice No</b></TableCell>
                                    <TableCell><b>Name</b></TableCell>
                                    <TableCell><b>Customer Type</b></TableCell>
                                    <TableCell><b>Term</b></TableCell>
                                    <TableCell><b>Due Date</b></TableCell>
                                    <TableCell><b>Total Amount</b></TableCell>
                                    <TableCell><b>Status</b></TableCell>
                                    <TableCell><b></b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    <Box sx={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100vw',
                                        height: '100vh',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        bgcolor: 'white',
                                        zIndex: 9999
                                    }}>
                                        <l-trio
                                            size="50"
                                            speed="1.3"
                                            color="red"
                                        ></l-trio>
                                    </Box>
                                ) : (
                                    filteredData.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={10} align="center">
                                                <Typography variant="body1">No invoices found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        filteredData
                                            .sort((a, b) => {
                                                const dateComparison = new Date(b.invoicedate) - new Date(a.invoicedate);

                                                if (dateComparison !== 0) {
                                                    return dateComparison;
                                                }

                                                return b.id - a.id;
                                            }).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((order, index) => (
                                                <React.Fragment key={index}>
                                                    <TableRow
                                                        hover
                                                        onClick={() => handleRowClick(index)}
                                                        role="checkbox"
                                                        aria-checked={isSelected(order.id)}
                                                        tabIndex={-1}
                                                        selected={isSelected(order.id)}
                                                        sx={{
                                                            '& td, & th': { padding: '8px 12px' },
                                                            backgroundColor: openRow === index ? '#f0f0f0' : 'inherit',
                                                        }}
                                                    >
                                                        <TableCell padding="checkbox" sx={{ color: '#636363' }}>
                                                            <Checkbox
                                                                checked={isSelected(order.id)}
                                                                onChange={(event) => handleRowSelect(event, order.id)}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={{ fontSize: '14px' }}>
                                                                {order.invoicedate}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={{ fontSize: '14px' }}>
                                                                {order.invoiceNo}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            {(!emptyUserSubscription || isFreePlan || expire) ? (
                                                                <Typography sx={{ fontSize: '14px' }}>
                                                                    {order.fullname}
                                                                </Typography>
                                                            ) : (
                                                                <Link to={`/orders/${encodeURIComponent(order.fullname)}`} style={{ textDecoration: 'none' }}>
                                                                    <Typography sx={{ fontSize: '14px', color: 'blue', cursor: 'pointer' }}>
                                                                        {order.fullname}
                                                                    </Typography>
                                                                </Link>
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={{ fontSize: '14px' }}>
                                                                {order.customer}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={{ fontSize: '14px' }}>
                                                                {order.term === 'due on receipt' && 'Payment on Receipt'}
                                                                {order.term === 'net 15' && 'Credit Term - 15 Days'}
                                                                {order.term === 'net 30' && 'Credit Term - 30 Days'}
                                                                {order.term === 'net 60' && 'Credit Term - 60 Days'}
                                                            </Typography>
                                                        </TableCell>


                                                        <TableCell>
                                                            <Typography sx={{ fontSize: '14px' }}>
                                                                {order.duedate}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography sx={{ fontSize: '14px' }}>
                                                                LKR.{calculateTotalAmount(order.items, order.discount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography
                                                                variant="body2"
                                                                style={{
                                                                    color:
                                                                        order.term === 'due on receipt'
                                                                            ? 'green'
                                                                            : order.payamount === 0
                                                                                ? 'red'
                                                                                : calculateTotalAmount(order.items, order.discount) <=
                                                                                    (Number(order.payamount) + calculateOrderTotalPayments(order.id))
                                                                                    ? 'green'
                                                                                    : 'orange',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '5px',
                                                                }}
                                                            >
                                                                {order.term === 'due on receipt' ||
                                                                    calculateTotalAmount(order.items, order.discount) <=
                                                                    (Number(order.payamount) + calculateOrderTotalPayments(order.id)) ? (
                                                                    <>
                                                                        <CheckCircle fontSize="small" style={{ color: 'green' }} />
                                                                        Paid
                                                                    </>
                                                                ) : order.payamount === 0 ? (
                                                                    'Unpaid'
                                                                ) : (
                                                                    'Pending'
                                                                )}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box alignItems="center">
                                                                <div onClick={(e) => e.stopPropagation()}>
                                                                    <IconButton onClick={(e) => handleMenuOpen2(e, index)}>
                                                                        <MoreVertIcon />
                                                                    </IconButton>
                                                                    <Menu
                                                                        anchorEl={anchorE2}
                                                                        open={openMenuRowIndex === index}
                                                                        onClose={handleMenuClose2}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        <MenuItem onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleEditClick(order);
                                                                            handleMenuClose2();
                                                                        }}
                                                                            sx={{
                                                                                fontSize: '15px',
                                                                                minHeight: 'auto',
                                                                                py: 0.5
                                                                            }}
                                                                        >
                                                                            <EditNoteIcon sx={{
                                                                                mr: 1,
                                                                                fontSize: '19px'
                                                                            }} />
                                                                            Edit
                                                                        </MenuItem>

                                                                        {order.term !== 'due on receipt' && (
                                                                            <MenuItem onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handleOpenPaymentDialog(order);
                                                                                handleMenuClose2();
                                                                            }}
                                                                                sx={{
                                                                                    fontSize: '15px',
                                                                                    minHeight: 'auto',
                                                                                    py: 0.5
                                                                                }}
                                                                            >
                                                                                <PaymentsIcon sx={{
                                                                                    mr: 1,
                                                                                    fontSize: '19px'
                                                                                }} />
                                                                                Make Payment
                                                                            </MenuItem>
                                                                        )}

                                                                        <MenuItem onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleDelete2(order.id);
                                                                            handleMenuClose2();
                                                                        }}
                                                                            sx={{
                                                                                fontSize: '15px',
                                                                                minHeight: 'auto',
                                                                                py: 0.5
                                                                            }}
                                                                        >
                                                                            <DeleteIcon sx={{
                                                                                mr: 1,
                                                                                fontSize: '19px'
                                                                            }} />
                                                                            Delete
                                                                        </MenuItem>
                                                                        <MenuItem
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                handlePrintSingleClick(order);
                                                                            }}
                                                                            sx={{
                                                                                fontSize: '15px',
                                                                                minHeight: 'auto',
                                                                                py: 0.5
                                                                            }}
                                                                        >
                                                                            <PrintIcon
                                                                                sx={{
                                                                                    mr: 1,
                                                                                    fontSize: '19px'
                                                                                }}
                                                                            />
                                                                            Print
                                                                        </MenuItem>
                                                                        <MenuItem
                                                                            onClick={(e) => { e.stopPropagation(); handlePreviewClick(order); }}
                                                                            sx={{ fontSize: '15px', minHeight: 'auto', py: 0.5 }}
                                                                        >
                                                                            <Share2 style={{ marginRight: '8px', width: '19px', height: '19px' }} />
                                                                            Share
                                                                        </MenuItem>
                                                                    </Menu>
                                                                </div>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>

                                                    {/* Collapsible Row Details */}
                                                    <TableRow>
                                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                                                            <Collapse in={openRow === index} timeout="auto" unmountOnExit>
                                                                <Box margin={1} padding={2} bgcolor="#f9f9f9" borderRadius={4} >
                                                                    <Typography variant="h6" gutterBottom component="div" color="primary">
                                                                        Order Details <span >#{order.pay_id}</span>
                                                                    </Typography>
                                                                    <Table size="small" aria-label="purchases">
                                                                        <TableHead>
                                                                            <TableRow>
                                                                                <TableCell><b>Product</b></TableCell>
                                                                                <TableCell><b>Qty</b></TableCell>
                                                                                <TableCell><b>Rate</b></TableCell>
                                                                                <TableCell><b>Price</b></TableCell>
                                                                                <TableCell><b>Tax</b></TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {order.items.map((item, idx) => (
                                                                                <TableRow key={idx}>
                                                                                    <TableCell sx={{ color: '#636363', fontSize: '14px' }}>{item.product}</TableCell>
                                                                                    <TableCell sx={{ color: '#636363', fontSize: '14px' }}>{item.quantity}</TableCell>
                                                                                    <TableCell sx={{ color: '#636363', fontSize: '14px' }}>LKR.{Number(item.rate || 0).toFixed(2)}</TableCell>
                                                                                    <TableCell sx={{ color: '#636363', fontSize: '14px' }}>LKR.{Number(item.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                                                                    <TableCell sx={{ color: '#636363', fontSize: '14px' }}>{item.tax}</TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                            <TableRow>
                                                                                <TableCell colSpan={3} align="right">
                                                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>Total</Typography>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                                        LKR.{order.items.reduce((acc, item) => acc + (item.quantity * item.rate), 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                    </Typography>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell colSpan={3} align="right">
                                                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>Discount</Typography>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>{order.discount}%</Typography>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                            <TableRow>
                                                                                <TableCell colSpan={3} align="right">
                                                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>Pay Amount</Typography>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                                        LKR. {order.term === 'due on receipt'
                                                                                            ? (calculateTotalAmount(order.items, order.discount)).toFixed(2)
                                                                                            : ((Number(order.payamount) + calculateOrderTotalPayments(order.id))).toFixed(2)}
                                                                                    </Typography>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                            {order.term !== 'due on receipt' && (
                                                                                <TableRow>
                                                                                    <TableCell colSpan={3} align="right">
                                                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>Pay Due</Typography>
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                                            LKR.{(calculateTotalAmount(order.items, order.discount) - ((Number(order.payamount) + calculateOrderTotalPayments(order.id)))).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                        </Typography>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            )}
                                                                            <TableRow>
                                                                                <TableCell colSpan={3} align="right">
                                                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>Grand Total</Typography>
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    <Typography sx={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                                                        LKR.{(calculateTotalAmount(order.items, order.discount)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                                                    </Typography>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        </TableBody>
                                                                    </Table>
                                                                    <Typography sx={{ fontSize: '14px' }} gutterBottom component="div" color="textSecondary" mt={2}>
                                                                        Description
                                                                    </Typography>
                                                                    <Typography variant="body2" gutterBottom component="div">
                                                                        {order.description}
                                                                    </Typography>
                                                                </Box>
                                                            </Collapse>
                                                        </TableCell>
                                                    </TableRow>
                                                </React.Fragment>
                                            ))
                                    )
                                )}
                            </TableBody>
                        </Table>

                        <Box
                            display="flex"
                            justifyContent="center"
                            width="100%"
                            mt={2}
                        >
                            <TablePagination
                                rowsPerPageOptions={[100, 200, 300]}
                                component="div"
                                count={filteredData.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage=""
                            />
                        </Box>
                    </TableContainer>
                </Box>

                {/**make payment dialog box */}
                <Dialog open={paymentDialogOpen} onClose={handleClosePaymentDialog}>
                    <DialogTitle>Make Payment</DialogTitle>
                    <DialogContent>
                        <MakePayment order={selectedOrder} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClosePaymentDialog} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>

                {/*popup edit dialog box */}
                <Box>
                    <Dialog
                        open={editDialogOpen}
                        onClose={() =>
                            setEditDialogOpen(false)}
                        TransitionComponent={Transition}
                        maxWidth="xl"
                    >
                        <AppBar sx={{ position: 'relative', bgcolor: '#FAFAFA', boxShadow: 'none', borderBottom: '1px solid #e0e0e0' }}>
                            <Toolbar>
                                <Typography sx={{ ml: 2, flex: 1, color: 'black', fontWeight: 'bold' }} variant="h6" component="div">
                                    Edit Invoice
                                </Typography>
                                <IconButton edge="end" color="inherit" onClick={handleCloseEditDialog} aria-label="close">
                                    <CloseIcon sx={{ color: 'red' }} />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <DialogContent>
                            <Grid container spacing={2} mt={1}>
                                <Grid item xs={12} sm={6} md={3}>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <InputLabel>Customer</InputLabel>
                                        <Select
                                            label="Customer"
                                            value={editOrder?.customer || ''}
                                            onChange={(e) => handleAutoFill('customer', e.target.value)}
                                            fullWidth
                                            size="small"
                                        >
                                            <MenuItem value="Direct Customer">Direct Customer</MenuItem>
                                            <ListSubheader>Existing Customers</ListSubheader>
                                            {customers.map((customer) => (
                                                <MenuItem key={customer.id} value={customer.id}>
                                                    {customer.firstname}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        label="Full Name"
                                        value={editOrder?.fullname || ''}
                                        onChange={(e) => handleAutoFill('fullname', e.target.value)}
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        label="Email"
                                        value={editOrder?.email || ''}
                                        onChange={(e) => handleAutoFill('email', e.target.value)}
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        label="Address"
                                        value={editOrder?.address || ''}
                                        onChange={(e) => handleAutoFill('address', e.target.value)}
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel>Term</InputLabel>
                                        <Select
                                            value={editOrder?.term || ''}
                                            onChange={(e) => handleEditChange('term', e.target.value)}
                                            label="Term"
                                        >
                                            <MenuItem value="due on receipt">Due on Receipt</MenuItem>
                                            <MenuItem value="net 15">Net 15</MenuItem>
                                            <MenuItem value="net 30">Net 30</MenuItem>
                                            <MenuItem value="net 60">Net 60</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        label="Invoice Date"
                                        value={editOrder?.invoicedate || ''}
                                        onChange={(e) => handleEditChange('invoicedate', e.target.value)}
                                        fullWidth
                                        type='date'
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        label="Due Date"
                                        value={editOrder?.duedate || ''}
                                        onChange={(e) => handleEditChange('duedate', e.target.value)}
                                        InputProps={{ readOnly: true }}
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                            </Grid>

                            <Box
                                sx={{
                                    textAlign: 'right',
                                    marginTop: '10px',
                                    marginRight: '10px',
                                    padding: '10px',
                                }}
                            >
                                <h3 style={{ margin: 0 }}>TOTAL </h3>
                                <p style={{ fontSize: '30px', margin: 0, fontWeight: 'bold' }}>LKR.{calculateTotalPrice()}</p>
                            </Box>

                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '20px', marginBottom: '10px' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleAddNewItem}
                                    style={{ backgroundColor: 'black', color: 'white' }}
                                    sx={{
                                        height: '30px',
                                    }}
                                >
                                    <PlaylistAddIcon />
                                </Button>
                            </Box>



                            <TableContainer
                                size="small"
                                sx={{
                                    maxHeight: '400px', // Set a max height for the container
                                    overflowY: 'auto',  // Enable vertical scrolling for overflow
                                    '@media (max-width:600px)': { // Media query for small screens
                                        '& .MuiTableCell-root': {
                                            padding: '4px', // Reduce padding for small screens
                                            fontSize: '0.8rem' // Decrease font size for readability
                                        },
                                        '& .MuiTextField-root': {
                                            minWidth: '100px', // Ensure text fields have a minimum width
                                        },
                                        '& .MuiSelect-root': {
                                            minWidth: '100px', // Ensure selects have a minimum width
                                        },
                                        '& .MuiIconButton-root': {
                                            padding: '4px' // Reduce padding for icon buttons
                                        }
                                    }
                                }}
                            >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Product</TableCell>
                                            <TableCell>Qty</TableCell>
                                            <TableCell>Rate</TableCell>
                                            <TableCell>Price</TableCell>
                                            <TableCell>Tax</TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {editOrder?.items.map((item, index) => (
                                            <TableRow key={index} sx={{ height: '20px' }}>
                                                <TableCell sx={{ padding: '8px' }}>
                                                    <FormControl fullWidth size="small" variant="outlined">
                                                        <InputLabel>Product</InputLabel>
                                                        <Select
                                                            value={item.product}
                                                            onChange={(e) => handleProductChange(index, e.target.value)}
                                                            label="Product"
                                                            sx={{ width: '100%' }}
                                                        >
                                                            {Object.keys(productPrices).map((product) => (
                                                                <MenuItem key={product} value={product}>
                                                                    {product}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell sx={{ padding: '8px' }}>
                                                    <TextField
                                                        label="Qty"
                                                        value={item.quantity}
                                                        onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                        fullWidth
                                                        size="small"
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        label="Rate"
                                                        value={item.rate}
                                                        onChange={(e) => handleRateChange(index, e.target.value)}
                                                        fullWidth
                                                        size="small"
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        label="Price"
                                                        value={Number(item.price).toFixed(2)}
                                                        onChange={(e) => handleEditItemChange(index, 'price', e.target.value)}
                                                        fullWidth
                                                        size="small"
                                                        InputProps={{ readOnly: true }}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        label="Tax"
                                                        value={item.tax}
                                                        onChange={(e) => handleEditItemChange(index, 'tax', e.target.value)}
                                                        fullWidth
                                                        size="small"
                                                        type='number'
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <IconButton onClick={() => handleDeleteItem(index)}
                                                        sx={{
                                                            '&:hover': {
                                                                color: 'red',
                                                            },
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        margin="normal"
                                        label="Description"
                                        multiline
                                        rows={3}
                                        size="small"
                                        value={editOrder?.description || ''}
                                        onChange={(e) => handleAutoFill('description', e.target.value)}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid container item xs={12} sm={6} spacing={2} justifyContent="flex-end">
                                    <Grid item xs={6}>
                                        <TextField
                                            margin="normal"
                                            label="Discount"
                                            size="small"
                                            type='number'
                                            value={editOrder?.discount || ''}
                                            onChange={(e) => handleEditChange('discount', e.target.value)}
                                            fullWidth
                                        />
                                        <TextField
                                            margin="normal"
                                            label="Pay Amount"
                                            size="small"
                                            type='number'
                                            value={editOrder?.payamount || ''}
                                            onChange={(e) => handleEditChange('payamount', e.target.value)}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            {/**<Button onClick={() => setEditDialogOpen(false)} color="primary">
                                Cancel
                            </Button>*/}
                            <Button variant='contained' onClick={handleEditSave} color="primary">
                                Save Changes
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>

                <Dialog open={isSharing}>
                    <DialogContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <CircularProgress size={24} />
                        <Typography>Generating PDF...</Typography>
                    </DialogContent>
                </Dialog>

                <Dialog open={pdfPreviewOpen} onClose={handleClosePreview} fullWidth maxWidth="md">
                    <DialogTitle>Invoice Preview</DialogTitle>
                    <DialogContent>
                        {pdfUrl ? (
                            <iframe
                                src={pdfUrl}
                                title="Invoice Preview"
                                width="100%"
                                height="500px"
                                style={{ border: 'none' }}
                            />
                        ) : (
                            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                                <CircularProgress />
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClosePreview}>Close</Button>
                        <Button onClick={executeShare} variant="contained" startIcon={<Share2 size={16} />}>
                            Share
                        </Button>
                    </DialogActions>
                </Dialog>

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                    <Alert
                        onClose={handleSnackbarClose}
                        severity={snackbarSeverity}
                        sx={{
                            width: '100%',

                        }}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>

                <>
                    {openDialog2 && (
                        <Dialog
                            open={openDialog2}
                            onClose={closeDialog2}
                            TransitionComponent={Fade}
                            transitionDuration={500}
                        >
                            {/* Centered Icon */}
                            <Box display="flex" justifyContent="center" mt={2}>
                                <ClockFading size={40} />
                            </Box>

                            <DialogTitle>Payment Due Tomorrow - Invoice #{invoiceNo}</DialogTitle>
                            <DialogContent>
                                <Typography>Invoice No: {invoiceNo}</Typography>
                                <Typography>Due Amount: LKR.{dueAmount.toFixed(2)}</Typography>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={closeDialog2}
                                    style={{ backgroundColor: 'red', color: 'white' }}
                                >
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                </>
            </Box>
            <ScrollToTopButton />
        </Box>
    );
};

export default InvoiceTable;
